import { UserStatuses } from "src/app/_enums/users-statuses.enum";
export class PersonalInformation {

  id?: string;
  profileImg: string ="/assets/Icons/StudentsSmall.png";
  birthDate: Date;
  genderId: number;
  bloodGroupId: number;
  firstName: string;
  secondName: string;
  thirdName: string;
  lastName: string;
  firstNameEn: string;
  secondNameEn: string;
  thirdNameEn: string;
  lastNameEn: string;
  userType: number;
  statusId: number = UserStatuses.New;
  isDeleted: boolean = false;
  religionId: number;
  placeOfBirth: string;
  weight: number;
  height: number;
  specialNeeds: boolean = false;
  // to do remove
  languagesIds: number[] = [];
}
